import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex items-center justify-center max-h-screen h-screen" }
const _hoisted_2 = { class: "absolute top-1 left-1 text-[10px]" }
const _hoisted_3 = { class: "flex flex-col items-center gap-4 rounded-lg shadow-lg border border-gray-300 p-4 text-center" }
const _hoisted_4 = {
  key: 0,
  class: "text-red-500 text-sm mt-2"
}

import { ref, onMounted } from "vue";
import { setCookie, getCookie, deleteCookie } from "../utils/cookies";
import { useGeneralStore } from "../stores/general";
import GenericButton from "./ui/GenericButton.vue";
import { scrollToInput } from "../utils/common";


export default /*@__PURE__*/_defineComponent({
  __name: 'SetBoothKey',
  emits: ["change-view"],
  setup(__props, { emit: __emit }) {

const general = useGeneralStore();
const key = ref("");
const errorMessage = ref("");
const loading = ref(false);
const sessionEmail = ref("");
const emits = __emit;

async function validateKey(event: any, isNewTry = false) {
  event.preventDefault();
  event.stopPropagation();
  loading.value = true;
  if (key.value.length < 8 || key.value.length > 32) {
    loading.value = false;
    errorMessage.value = "La clave debe tener entre 8 y 32 caracteres";
    return;
  }
  const fingerprint = getCookie("fingerprint") as string;
  if (!fingerprint && !isNewTry) {
    general.generateFingerprint(() => {
      validateKey(event, true);
    });
    loading.value = false;
    return;
  } else if (!fingerprint && isNewTry) {
    errorMessage.value = "No se logró generar la huella digital";
    loading.value = false;
    return;
  }
  const days = general.getBooth.customConfig?.duracionSesion;
  setCookie("fingerprint", fingerprint, days);
  const session = await general.getSession();
  const accessToken = session.tokens?.accessToken as object;
  const res = (await general.postMedicalBoothsValidation({
    claveCabina: key.value,
    fingerprint: fingerprint,
    accessToken: accessToken,
  })) as any;
  if (res.code === 200) {
    setCookie("booth", key.value, days);
    general.setBooth(res.data);
    emits("change-view", "baseInformation");
  } else {
    deleteCookie("booth");
    deleteCookie("fingerprint");
  }
  errorMessage.value = res.message;
  loading.value = false;
}

async function handleClick() {
  if (!document || !document.exitFullscreen) {
    errorMessage.value = "No se puede salir de pantalla completa...";
    return;
  }
  await document.exitFullscreen();
}

onMounted(() => {
  general.getSession().then((session) => {
    sessionEmail.value =
      session?.tokens?.signInDetails?.loginId?.split("@")[0] || "";
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", null, _toDisplayString(sessionEmail.value), 1)
    ]),
    _createVNode(GenericButton, {
      variant: "ghost",
      onClick: handleClick,
      class: "absolute top-0 right-3 text-primary-500"
    }, {
      default: _withCtx(() => _cache[3] || (_cache[3] = [
        _createTextVNode(" Salir ")
      ])),
      _: 1,
      __: [3]
    }),
    _createElementVNode("div", _hoisted_3, [
      _cache[5] || (_cache[5] = _createElementVNode("h1", { class: "text-2xl font-bold text-primary-900" }, " Ingrese clave de cabina ", -1)),
      _cache[6] || (_cache[6] = _createElementVNode("hr", { class: "my-4 border-gray-200 w-full" }, null, -1)),
      _createElementVNode("form", {
        class: "flex flex-col gap-4",
        onSubmit: _cache[2] || (_cache[2] = _withModifiers((event) => validateKey(event), ["prevent"]))
      }, [
        _withDirectives(_createElementVNode("input", {
          onFocus: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(scrollToInput) && _unref(scrollToInput)(...args))),
          type: "text",
          id: "key",
          name: "key",
          class: "w-full border border-gray-300 rounded p-2",
          placeholder: "Clave de cabina",
          required: "",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((key).value = $event))
        }, null, 544), [
          [_vModelText, key.value]
        ]),
        _createVNode(GenericButton, {
          variant: "primary",
          type: "submit",
          disabled: loading.value,
          loading: loading.value,
          class: "bg-gradient-to-r from-primary-400 to-primary-900 text-white px-4 py-2 rounded-full mt-4"
        }, {
          default: _withCtx(() => _cache[4] || (_cache[4] = [
            _createTextVNode(" Validar ")
          ])),
          _: 1,
          __: [4]
        }, 8, ["disabled", "loading"])
      ], 32),
      (errorMessage.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(errorMessage.value), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})